<template>
    <div class="col-lg-1 col-sm-1 col-1">

        <ul @click="active2">
            <li class="d-lg-none" style="color: #9d9d9d;margin-left: -50px;position: absolute; top: 30%; font-size: 25px;" ><span ><i class="fa fa-bars" aria-hidden="true"></i></span>
            </li>

        </ul>
    </div>
    <div class="col-sm-12 d-lg-none">
        <div class="mobile-menu mean-container"><div class="mean-bar"><span class="meanmenu-reveal" style="right:0;left:auto;"></span><nav class="mean-nav">
            <ul v-bind:style="{ display: activeColor}">
                <li><a style="text-align: center" href="/products/all">دسته بندی محصولات</a>
                    <!-- Home Version Dropdown Start -->
                    <ul v-bind:style="{ display: activeColor}">
                        <li v-for="data_catrgory in data_catrgorys" :key="data_catrgory.id"><a style="text-align: right" v-bind:href="'/category/'+data_catrgory.slug_ca">{{data_catrgory.name}}</a></li>
                    </ul>
                    <!-- Home Version Dropdown End -->
                   </li>
                <li><a style="text-align: center" href="/products/all">برند ها</a>
                    <!-- Mobile Menu Dropdown Start -->
                    <ul v-bind:style="{ display: activeColor}">
                        <li v-for="data_brand in data_brands" :key="data_brand.id"><a style="text-align: right" v-bind:href="'/brand/'+data_brand.title">{{data_brand.title}}</a></li>
                    </ul>
                    <!-- Mobile Menu Dropdown End -->
                    </li>
                <li><a href="/partners">صفحه ویژه همکاران</a>
                </li>
                <li><a href="/ventilation/guide">راهنمای انتخاب فن</a>
                </li>
                <li><a href="/about-us">درباره ما</a></li>
                <li class="mean-last"><a href="/contact-us">تماس با ما</a></li>
            </ul>
        </nav></div>
            <div class="mean-push"></div>
        </div>
    </div>
</template>

<script>
    import {reactive, ref} from "vue";


    export default {
        name: "MenuMoblie",
        props:['catrgory','brand'],
            setup(props) {

                const data_catrgorys = reactive(props.catrgory);
                const data_brands = reactive(props.brand);
                const activeColor = ref('none');

                const active2 = () => {
                    console.log(data_catrgorys);
                    if(activeColor.value=='none'){
                        activeColor.value='block';
                    }else{
                        activeColor.value='none';
                    }
                }
                return {
                    active2,
                    activeColor,
                    data_catrgorys,
                    data_brands

                };
            },

        };
</script>

<style scoped>

</style>
